import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h2", null, "页面自定义内容", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { style: {"height":"50px"} }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h2", null, "antd 组件库内容", -1)

import { ref } from 'vue'
import useLocale from '@/hooks/useLocale'
import { useI18n } from 'vue-i18n'

const __default__ = { name: 'Example' }


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const { t } = useI18n()
const { languageToggle } = useLocale()

const language = ref<string>('zh_CN')
const handleLang = () => {
  languageToggle(language.value)
}

return (_ctx: any,_cache: any) => {
  const _component_a_radio_button = _resolveComponent("a-radio-button")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_dc_layout_button_group = _resolveComponent("dc-layout-button-group")!
  const _component_a_pagination = _resolveComponent("a-pagination")!
  const _component_a_range_picker = _resolveComponent("a-range-picker")!
  const _component_dc_layout_content = _resolveComponent("dc-layout-content")!
  const _component_dc_layout_main = _resolveComponent("dc-layout-main")!

  return (_openBlock(), _createBlock(_component_dc_layout_main, { "is-breadcrumb": true }, {
    default: _withCtx(() => [
      _createVNode(_component_dc_layout_content, null, {
        default: _withCtx(() => [
          _hoisted_1,
          _createElementVNode("div", null, [
            _createVNode(_component_a_radio_group, {
              value: language.value,
              "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((language).value = $event)),
              "button-style": "solid",
              onChange: handleLang
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_radio_button, { value: "zh_CN" }, {
                  default: _withCtx(() => [
                    _createTextVNode("中文")
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_radio_button, { value: "en_US" }, {
                  default: _withCtx(() => [
                    _createTextVNode("英文")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["value"])
          ]),
          _createVNode(_component_dc_layout_button_group, null, {
            default: _withCtx(() => [
              _createVNode(_component_a_button, { type: "primary" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('example.edit')), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_a_button, { type: "primary" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('example.publish')), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_a_button, { type: "primary" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('example.draft')), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_a_button, { type: "primary" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('example.delete')), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_a_button, { type: "primary" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('example.cancel')), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_a_button, { type: "primary" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('example.confirm')), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _hoisted_2,
          _hoisted_3,
          _createVNode(_component_a_pagination, { total: 500 }),
          _createVNode(_component_a_range_picker)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})